import React from "react";
import { Star, Home, ShieldCheck, Sparkles, BadgeCheck } from "lucide-react";

const BADGES = [
  { icon: Home, label: "10,000 homes per drop" },
  { icon: BadgeCheck, label: "No long-term contracts" },
  { icon: Sparkles, label: "AI-powered CRM included" },
  { icon: ShieldCheck, label: "Locally owned & operated" },
];

const REVIEWS = [
  { q: "We booked 14 new installs from a single postcard drop — the phone didn't stop ringing.", n: "Dave R.", r: "HVAC · Springfield, MO" },
  { q: "The CRM follows up with every lead automatically. I haven't lost a single one since.", n: "Maria L.", r: "Realtor · Joplin, MO" },
  { q: "Best return we've ever gotten from local advertising. Neighbors know our name now.", n: "Tom B.", r: "Plumbing · Monett, MO" },
];

export default function SocialProof() {
  return (
    <section className="mt-16" data-testid="social-proof">
      <div className="flex flex-wrap justify-center gap-2.5 mb-10">
        {BADGES.map((b) => (
          <div key={b.label} data-testid={`trust-badge-${b.label.toLowerCase().replace(/\s/g, "-")}`}
            className="inline-flex items-center gap-2 rounded-full border border-border bg-card px-4 py-2 text-sm font-semibold text-sam-navy">
            <b.icon className="h-4 w-4 text-sam-crimson" />{b.label}
          </div>
        ))}
      </div>
      <div className="text-center mb-6">
        <div className="inline-flex items-center gap-1 text-sam-amber">
          {[...Array(5)].map((_, i) => <Star key={i} className="h-5 w-5 fill-current" />)}
        </div>
        <p className="text-sm text-sam-slate mt-1">Trusted by local businesses across the Midwest</p>
      </div>
      <div className="grid md:grid-cols-3 gap-4">
        {REVIEWS.map((rv) => (
          <div key={rv.n} data-testid={`review-${rv.n.toLowerCase().replace(/\W/g, "-")}`}
            className="rounded-2xl border border-border bg-card p-5">
            <div className="flex gap-0.5 text-sam-amber mb-2">{[...Array(5)].map((_, i) => <Star key={i} className="h-3.5 w-3.5 fill-current" />)}</div>
            <p className="text-sam-navy/90 text-sm leading-relaxed">"{rv.q}"</p>
            <div className="mt-3 text-xs font-semibold text-sam-navy">{rv.n} <span className="text-sam-slate font-normal">· {rv.r}</span></div>
          </div>
        ))}
      </div>
    </section>
  );
}
